import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { UnregisterCallback } from 'history';
import { useTranslation } from 'react-i18next';
import { history } from 'instantsearch.js/es/lib/routers';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { BREADCRUMBS_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity';

import SearchResults from './Results';
import { Breadcrumbs, SearchAllContent } from '../../components';
import { SEARCH_ALL_CONTENT_RESULTS } from '../../config/constants';

const Search: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const routerHistory = useHistory();

  const removeHistoryListener = useRef<UnregisterCallback>();

  const routing = {
    router: history({
      start: (onUpdate) => {
        removeHistoryListener.current = routerHistory.listen(onUpdate);
      },
      dispose: () => removeHistoryListener.current,
    }),
  };

  useEffect(() => {
    dispatch({
      type: BREADCRUMBS_LOADED,
      payload: [
        {
          title: 'Home',
          url: '/',
        },
      ],
    });
  }, [dispatch]);

  return (
    <div className="Search">
      <SearchAllContent routing={routing} hitsPerPage={SEARCH_ALL_CONTENT_RESULTS}>
        <Container>
          <div className="row">
            <div className="col-12">
              <Breadcrumbs />
            </div>
          </div>

          <h1>{t('pages.search.title')}</h1>

          <div className="mb-10">
            <div className="row">
              <div className="col-12">
                <SearchAllContent.SearchBar autoSearch timeout={300} fieldName="search-results" />
              </div>
            </div>
          </div>

          <SearchResults />
        </Container>
      </SearchAllContent>
    </div>
  );
};

export default Search;
